<template>
  <div>
    <div class="container-fluid c-title">
      <div class="text-center">
        <h1 class="light-shadow" style="font-size: 45px">
          {{ $t('home.title') }}
          <span class="span-accent">{{ $t('home.subtitle') }}</span>
        </h1>
        <p class="light-shadow">{{ $t('home.dates') }}</p>
      </div>
    </div>
    <div class="container container-home pt-4">
      <div class="row register-now" v-b-modal.reg-modal>
        <div class="col col-justify">
          <h2 class="h-sub pb-3">{{ $t('home.registerNow') }}</h2>
          <p>
            {{ $t('home.registerDescription') }}
          </p>
        </div>
        <div class="col-5 col-thumb">
          <img src="@/assets/img/thumb-hg.jpg" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="rewards-section">
            <h3 class="rewards-title">
              <span class="trophy-icon">🏆</span>
              {{ $t('home.rewards.title') }}
            </h3>
            <div class="rewards-container">
              <div class="reward-card first-place">
                <div class="reward-content">
                  <h4 class="reward-title">{{ $t('home.rewards.firstPlace.title') }}</h4>
                    <div class="reward-amount">{{ $t('home.rewards.firstPlace.totalAmount') }}</div>
                    <p class="reward-total-subtext">{{ $t('home.rewards.firstPlace.totalText') }}</p>
                    <p class="reward-description">{{ $t('home.rewards.firstPlace.perMember') }}</p>
                    <p class="reward-subtext">{{ $t('home.rewards.firstPlace.perMemberText') }}</p>
                </div>
                <div class="reward-icon">🥇</div>
              </div>
              
              <div class="reward-card second-place">
                <div class="reward-content">
                  <h4 class="reward-title">{{ $t('home.rewards.secondPlace.title') }}</h4>
                    <div class="reward-amount">{{ $t('home.rewards.secondPlace.totalAmount') }}</div>
                    <p class="reward-total-subtext">{{ $t('home.rewards.secondPlace.totalText') }}</p>
                    <p class="reward-description">{{ $t('home.rewards.secondPlace.perMember') }}</p>
                    <p class="reward-subtext">{{ $t('home.rewards.secondPlace.perMemberText') }}</p>
                </div>
                <div class="reward-icon">🥈</div>
              </div>
              
              <div class="reward-card third-place">
                <div class="reward-content">
                  <h4 class="reward-title">{{ $t('home.rewards.thirdPlace.title') }}</h4>
                    <div class="reward-amount">{{ $t('home.rewards.thirdPlace.totalAmount') }}</div>
                    <p class="reward-total-subtext">{{ $t('home.rewards.thirdPlace.totalText') }}</p>
                    <p class="reward-description">{{ $t('home.rewards.thirdPlace.perMember') }}</p>
                    <p class="reward-subtext">{{ $t('home.rewards.thirdPlace.perMemberText') }}</p>
                </div>
                <div class="reward-icon">🥉</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h2 class="text-center h-title pb-5">{{ $t('home.aboutTitle') }}</h2>
          <p>
            {{ $t('home.aboutDescription') }}
          </p>
          <div class="row pt-4">
            <div class="col-md-6 col-lg-3 col-stage">
              <div class="d-stage s1">
                <h4><strong>{{ $t('home.stages.registration.title') }}</strong></h4>
                <p><em>{{ $t('home.stages.registration.date') }}</em></p>
                <p class="p-descr">
                  {{ $t('home.stages.registration.description') }}
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-stage">
              <div class="d-stage s2">
                <h4><strong>{{ $t('home.stages.stage1.title') }}</strong></h4>
                <p><em>{{ $t('home.stages.stage1.date') }}</em></p>
                <p class="p-descr">
                  {{ $t('home.stages.stage1.description') }}
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-stage">
              <div class="d-stage s3">
                <h4><strong>{{ $t('home.stages.stage2.title') }}</strong></h4>
                <p><em>{{ $t('home.stages.stage2.date') }}</em></p>
                <p class="p-descr">
                  {{ $t('home.stages.stage2.description') }}
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-stage">
              <div class="d-stage s4">
                <h4><strong>{{ $t('home.stages.stage3.title') }}</strong></h4>
                <p><em>{{ $t('home.stages.stage3.date') }}</em></p>
                <p class="p-descr">
                  {{ $t('home.stages.stage3.description') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-7 section-about">
        <div class="col">
          <div class="row">
            <div class="col">
              <h2 class="text-center pb-5 h-title">{{ $t('home.tournamentFlow.title') }}</h2>
            </div>
          </div>
          <div class="row r-about">
            <div class="col-lg-5">
              <img class="img-fluid" src="@/assets/img/hg-1.jpg" />
            </div>
            <div class="col col-justify">
              <p>
                {{ $t('home.tournamentFlow.description1') }}<br />
              </p>
            </div>
          </div>
          <div class="row r-about flex-column-reverse flex-lg-row">
            <div class="col col-justify">
              <p class="text-end">
                {{ $t('home.tournamentFlow.description2') }}
              </p>
            </div>
            <div class="col-lg-5">
              <img class="img-fluid" src="@/assets/img/hg-2.jpg" />
            </div>
          </div>
          <div class="row r-about">
            <div class="col-lg-5">
              <img class="img-fluid" src="@/assets/img/hg-3.jpg" />
            </div>
            <div class="col col-justify">
              <p>
                {{ $t('home.tournamentFlow.description3') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-7">
        <div class="col">
          <h2 class="text-center h-title pb-5">{{ $t('home.additionalInfo.title') }}</h2>
          <a :href="$t('home.additionalInfo.link')" target="_blank">
            {{ $t('home.additionalInfo.description') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style>
.c-title {
  background: url("~@/assets/img/home-h41.jpg") center / cover no-repeat;
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Rewards Section Styles */
.rewards-section {
  padding: 4rem 0;
}

.rewards-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--accent-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.trophy-icon {
  font-size: 2.5rem;
  filter: drop-shadow(0 0 10px rgba(235, 203, 99, 0.5));
}

.rewards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.reward-card {
  background: linear-gradient(135deg, var(--bg-content-color) 0%, #3a4a5c 100%);
  border-radius: 20px;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 280px;
}

.reward-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--accent-color), var(--light-accent-color));
}

.reward-card:hover {
  transform: translateY(-10px);
}

.reward-card.first-place {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #ffd700 100%);
  color: #000;
}

.reward-card.first-place::before {
  background: linear-gradient(90deg, #ff6b35, #f7931e);
}

.reward-card.second-place {
  background: linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 50%, #c0c0c0 100%);
  color: #000;
}

.reward-card.second-place::before {
  background: linear-gradient(90deg, #8e8e8e, #b8b8b8);
}

.reward-card.third-place {
  background: linear-gradient(135deg, #cd7f32 0%, #e6a85c 50%, #cd7f32 100%);
  color: #000;
}

.reward-card.third-place::before {
  background: linear-gradient(90deg, #8b4513, #a0522d);
}

.reward-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2rem 0;
}

.reward-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.reward-amount {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 0;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.reward-total-subtext {
  font-size: 0.9rem;
  opacity: 0.7;
  font-weight: 400;
  font-style: italic;
}

.reward-description {
  font-size: 1rem;
  opacity: 0.8;
  margin: 0;
  font-weight: 500;
}

.reward-subtext {
  font-size: 0.85rem;
  opacity: 0.6;
  font-weight: 400;
  margin-top: 0.25rem;
}

.reward-icon {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  font-size: 2rem;
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .rewards-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .reward-card {
    min-height: 250px;
    padding: 1.5rem;
  }
  
  .rewards-title {
    font-size: 2rem;
  }
  
  .reward-amount {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .reward-card {
    padding: 1rem;
    min-height: 220px;
  }
  
  .reward-amount {
    font-size: 2rem;
  }
  
  .reward-title {
    font-size: 1.2rem;
  }
}
</style>
